import React from 'react'

import BudgetFields from '@cinch/oxd-pages/lifestyle/src/components/step-1-budget/budget.component'
import PassengerFields from '@cinch/oxd-pages/lifestyle/src/components/step-2-passengers/passengers.component'
import RoadFields from '@cinch/oxd-pages/lifestyle/src/components/step-3-roads/roads.component'
import DistanceFields from '@cinch/oxd-pages/lifestyle/src/components/step-4-distance/distance.component'
import FrequencyFields from '@cinch/oxd-pages/lifestyle/src/components/step-5-frequency/frequency.component'
import AbstractFields from '@cinch/oxd-pages/lifestyle/src/components/step-6-abstract/abstract.component'
import TextualFields from '@cinch/oxd-pages/lifestyle/src/components/step-7-textual/textual.component'

export interface StepConfigurator {
  component: React.FunctionComponent<any>
  i18nFragment: string
  aside?: any
  intro?: string
}

const lifeStyleStepsConfig: StepConfigurator[] = [
  {
    component: BudgetFields,
    i18nFragment: 'budget',
  },
  { component: PassengerFields, i18nFragment: 'passengers' },
  { component: RoadFields, i18nFragment: 'roads' },
  { component: DistanceFields, i18nFragment: 'distance' },
  { component: FrequencyFields, i18nFragment: 'frequency' },
  { component: AbstractFields, i18nFragment: 'importanceAbstract' },
  { component: TextualFields, i18nFragment: 'textual' },
]

export default lifeStyleStepsConfig
